/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import { DataGrid } from "@mui/x-data-grid";
import {
  FIND_EXTERNAL_ORDER,
  DELETE_EXTERNAL_ORDER,
  UPDATE_EXTERNAL_ORDER_PRINTED_AT,
} from "../../graphql/ExternalOrder";
import Box from "@mui/material/Box";
import { FormControl, InputAdornment, OutlinedInput } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import Badge from "@mui/material/Badge";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PrintIcon from "@mui/icons-material/Print";

import { Link } from "react-router-dom";
import MyBreadcrumbs from "../MyBreadcrumbs";
import GlobalContext from "../../utils/GlobalContext";
import DrawerFilter from "./DrawerFilter";
import ExternalOrderPDF from "../PDF/ExternalOrderPDF";
import { chipColor } from "../../utils";
import dayjs from "dayjs";

const ExternalOrderPage = (props) => {
  const { role } = props;
  const { setGlobalLoading, setSnack } = React.useContext(GlobalContext);
  const [externalOrder, setExternalOrder] = React.useState([]);
  const [baseExternalOrder, setBaseExternalOrder] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [isSearch, setIsSearch] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [isFilter, setIsFilter] = React.useState(false);
  const [quarterly, setQuarterly] = React.useState(1);
  const [year, setYear] = React.useState(new Date().getFullYear());
  const [row, setRow] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const [id, setId] = React.useState(null);
  const [pageSize, setPageSize] = React.useState(10);

  const handleClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      field: "id",
      headerName: "No",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => `${params.api.getRowIndex(params.row.id) + 1}.`,
    },
    {
      field: "client",
      headerName: "Nama Pelanggan",
      flex: 2,
      minWidth: 220,
      valueGetter: (params) => params.row?.client?.name,
    },
    {
      field: "quarterly",
      headerName: "Cawu & Tahun",
      width: 160,
      valueGetter: (params) =>
        `Cawu ${params?.row?.quarterly} - Tahun ${params?.row?.year}`,
    },
    {
      field: "company",
      headerName: "CV",
      width: 70,
      renderCell: (params) => {
        return (
          <React.Fragment>
            <Chip
              label={params.row?.company}
              variant="filled"
              color={chipColor(params.row?.company)}
              size="small"
            />
          </React.Fragment>
        );
      },
    },
    {
      field: "employee",
      headerName: "Nama PIC",
      flex: 0.7,
      minWidth: 110,
      valueGetter: (params) => params.row?.employee?.name,
    },
    {
      field: "total_payment_fee",
      headerName: "Uang Masuk",
      flex: 1,
      minWidth: 150,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        `Rp. ${params.row?.total_payment_fee?.toLocaleString("id-ID")}`,
    },
    {
      field: "tax_admin_fee",
      headerName: "Expense Fee",
      flex: 1,
      minWidth: 150,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        `Rp. ${params.row?.tax_admin_fee?.toLocaleString("id-ID")}`,
    },
    {
      field: "total_sales",
      headerName: "Nominal Pembelanjaan",
      flex: 1,
      minWidth: 160,
      align: "right",
      headerAlign: "right",
      valueGetter: (params) =>
        `Rp. ${params.row?.total_sales?.toLocaleString("id-ID")}`,
    },
    {
      field: "eoid",
      headerName: "Aksi",
      width: 140,
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Detail" placement="top">
              <IconButton
                aria-label="detail"
                size="small"
                component={Link}
                to={`/admin/external_order/${params.row.id}`}
                target="__blank"
              >
                <VisibilityIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cetak Nota" placement="top">
              <IconButton
                aria-label="cetak"
                size="small"
                onClick={() => {
                  setRow(params.row);
                  setOpen(true);
                }}
                // onClick={() => ExternalOrderPDF(params.row, true)}
              >
                <PrintIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            {role === "ADMIN" && (
              <Tooltip title="Hapus" placement="top">
                <IconButton
                  aria-label="detail"
                  size="small"
                  onClick={() => {
                    setId(params.row.id);
                    setOpenConfirm(true);
                  }}
                >
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  const requestSearch = (value) => {
    setSearched(value);
  };

  const clearSearch = () => {
    setSearched("");
    setIsSearch(false);
    setExternalOrder([...baseExternalOrder]);
  };

  const doSearch = async () => {
    setIsSearch(true);
    let filteredRows;
    // eslint-disable-next-line array-callback-return
    filteredRows = externalOrder.filter((row) => {
      const search = searched.toLowerCase();
      let flag = false;

      if (row?.client?.name.toLowerCase().includes(search)) {
        flag = true;
      }

      if (flag) return row;
    });

    setExternalOrder(filteredRows);
  };

  /* FETCH DATA FIND_EXTERNAL_ORDER */
  const {
    loading: loadExternalOrder,
    data: dataExternalOrder,
    refetch,
  } = useQuery(FIND_EXTERNAL_ORDER, {
    variables: { quarterly: 1, year },
    fetchPolicy: "network-only",
    onError: (e) => console.log("error getting selor:", e),
  });

  React.useEffect(() => {
    if (loadExternalOrder) {
      setGlobalLoading(true);
    }
  }, []);

  React.useEffect(() => {
    if (dataExternalOrder) {
      setBaseExternalOrder(dataExternalOrder.findExternalOrderByQuarterly);
      setExternalOrder(dataExternalOrder.findExternalOrderByQuarterly);
      setGlobalLoading(false);
    }
  }, [dataExternalOrder]);

  const [getFilterExternalOrders] = useLazyQuery(FIND_EXTERNAL_ORDER, {
    fetchPolicy: "network-only",
    variables: { quarterly, year },
  });

  const doFilter = async () => {
    setIsFilter(true);
    setOpenDrawer(false);
    const data = await getFilterExternalOrders({
      variables: { quarterly, year },
    });

    setExternalOrder([...data.data?.findExternalOrderByQuarterly]);
  };

  const resetFilter = () => {
    setIsFilter(false);
    setOpenDrawer(false);
    setYear(new Date().getFullYear());
    setQuarterly(1);
    setExternalOrder([...baseExternalOrder]);
  };

  const [deleteExternalOrder] = useMutation(DELETE_EXTERNAL_ORDER, {
    onCompleted: (d) => {
      setSnack({
        variant: "success",
        message: "Data Belanja berhasil dihapus",
        opened: true,
      });
      setGlobalLoading(false);
      setOpenConfirm(false);
    },
    onError: (e) => {
      console.log("error insert unit: ", e);
      let message = e.message || "Data Belanja gagal dihapus";

      setGlobalLoading(false);
      setSnack({
        variant: "error",
        message,
        opened: true,
      });
    },
  });

  const [updatePrintedAt] = useMutation(UPDATE_EXTERNAL_ORDER_PRINTED_AT);

  const handlePrint = async (order, withFee) => {
    let printed_at = order?.printed_at;

    if (!printed_at) {
      try {
        const res = await updatePrintedAt({
          variables: { id: order.id, printed_at: dayjs().format("YYYY-MM-DD") },
        });
        printed_at = res?.data?.updateExternalOrderPrintedAt?.printed_at;

        const applyPrintedAt = (rows) =>
          rows.map((r) => (r.id === order.id ? { ...r, printed_at } : r));
        setExternalOrder((prev) => applyPrintedAt(prev));
        setBaseExternalOrder((prev) => applyPrintedAt(prev));
      } catch (e) {
        console.log("error update printed_at: ", e);
      }
    }

    ExternalOrderPDF(
      { ...order, printed_at: printed_at || dayjs().format("DD-MM-YYYY") },
      withFee,
    );
    setOpen(false);
    setRow({});
  };

  const handleDelete = async (id) => {
    await deleteExternalOrder({ variables: { id } });
    setOpenConfirm(false);
    refetch();
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          bgcolor: "background.paper",
          borderRadius: 1,
          alignItems: "center",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <MyBreadcrumbs data={["Transaksi", "Nota"]} />
        </Box>
        <Box
          sx={{
            p: 0.5,
            m: 0.5,
          }}
        >
          <FormControl size="small" margin="dense">
            <OutlinedInput
              name="search"
              margin="dense"
              id="search"
              placeholder="Cari No Referensi..."
              onChange={(e) => requestSearch(e.target.value)}
              value={searched}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  doSearch();
                }
              }}
              endAdornment={
                <InputAdornment position="end">
                  {isSearch && (
                    <IconButton onClick={() => clearSearch()}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  {!isSearch && (
                    <IconButton onClick={() => doSearch()}>
                      <SearchIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
        {role !== "MONITORING" && (
          <Box
            sx={{
              p: 0.5,
              m: 0.5,
            }}
          >
            <Tooltip title="Tambah" placement="top">
              <IconButton
                aria-label="add"
                size="small"
                component={Link}
                to={"/admin/external_order/new"}
                style={{ backgroundColor: "#1976d2", color: "white" }}
              >
                <AddIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        <Box
          sx={{
            p: 0.5,
            m: 0.5,
          }}
        >
          <Tooltip title="Filter" placement="top">
            <IconButton
              aria-label="add"
              size="small"
              onClick={() => setOpenDrawer(true)}
              style={{ backgroundColor: "#1976d2", color: "white" }}
            >
              <Badge invisible={!isFilter} color="error" variant="dot">
                <FilterListIcon fontSize="inherit" />
              </Badge>
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          borderRadius: 2,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <DataGrid
          autoHeight
          rows={externalOrder}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 25]}
          disableSelectionOnClick
          getRowHeight={() => "auto"}
          sx={{
            border: "none",
            "& .MuiDataGrid-columnHeaders": {
              bgcolor: "grey.100",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 600,
            },
            "& .MuiDataGrid-cell": {
              py: 1,
              whiteSpace: "normal !important",
              wordWrap: "break-word !important",
              lineHeight: 1.4,
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              bgcolor: "rgba(0, 0, 0, 0.02)",
            },
            "& .MuiDataGrid-row:hover": {
              bgcolor: "action.hover",
            },
          }}
        />
      </Paper>

      <DrawerFilter
        open={openDrawer}
        setOpen={setOpenDrawer}
        quarterly={quarterly}
        setQuarterly={setQuarterly}
        doFilter={doFilter}
        resetFilter={resetFilter}
        year={year}
        setYear={setYear}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Cetak Laporan Nota</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id='alert-dialog-description'>
            Let Google help apps determine location. This means sending
            anonymous location data to Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handlePrint(row, false)} autoFocus>
            Cetak Tagihan
          </Button>
          <Button onClick={() => handlePrint(row, true)}>
            Cetak Tagihan + Biaya
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Hapus Data Nota</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Apakah anda yakin ingin menghapus data Nota ini?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleDelete(id)}
            autoFocus
          >
            Ya
          </Button>
          <Button
            variant="contained"
            color="info"
            onClick={() => setOpenConfirm(false)}
          >
            Tidak
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ExternalOrderPage;
